<template>
  <Head title="Direct Mail - Edit File Layout" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0">
          <file-layout-edit 
            :client="client" 
            :layout="layout"
            :data_blend="data_blend"
          ></file-layout-edit>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';

defineProps({
  client: Object,
  layout: {
    type: Object,
    default: null
  },
  data_blend: Object
});
</script>

